import FilterModel from '../searchFilter/index.model.js';
const model = {
    name: 'Bury',
    properties: {
        filter: { type: 'model', model: FilterModel, required: true },
    },
};
export default model;
